import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7">
    <path fill="none" fillRule="evenodd" stroke="#6A6A6A" strokeWidth="1.5" d="M1.05.5L6 5.45 10.95.5" />
  </svg>
);
